const formInputsData = {
    1: [
        {
            name: "u_first_name",
            label: "Full Name",
            type: "text",
            required: true,
            col: 12,
            inputFullWidth: true,
        },
        {
            name: "u_email",
            label: "Email",
            type: "email",
            required: true,
            col: 6,
        },
        {
            name: "u_phone",
            label: "Phone",
            type: "tel",
            required: true,
            col: 6,
        },
        {
            name: "u_company",
            label: "Company Name",
            type: "text",
            required: false,
            col: 6,
        },
        {
            name: "u_company_position",
            label: "Position in Company",
            type: "text",
            required: false,
            col: 6,
        },
        {
            name: "used_ppc_before",
            label: "Have you used Google Ads before?",
            type: "radio",
            required: true,
            col: 12,
            options: [
                {
                    label: "Yes",
                    value: "Yes",
                },
                {
                    label: "No",
                    value: "No",
                },
            ],
        },
        {
            name: "u_describes_business",
            label: "What best describes your business?",
            subLabel: "Select one that apply",
            type: "radio",
            required: false,
            col: 12,
            options: [
                {
                    label: "Local service business (e.g. plumber, contractor, dentist)",
                    value: "Local service business (e.g. plumber, contractor, dentist)",
                },
                {
                    label: "eCommerce or online store",
                    value: "eCommerce or online store",
                },
                {
                    label: "B2B / Professional services",
                    value: "B2B / Professional services",
                },
                {
                    label: "Franchise or multi-location business",
                    value: "Franchise or multi-location business",
                },
                {
                    label: "Other (please specify)e",
                    value: "Other (please specify)e",
                }
            ],
        },
    ],
};

const errorsData = {
	required: {
		default: "This field is required",
		u_first_name: "First name is required",
		u_last_name: "Last name is required",
		u_email: "Email is required",
		u_phone: "Phone is required",
		u_website: "Please answer the question",
		u_website_url: "Please enter your website URL",
		u_looking_improve: "Please select at least one option",
        u_describes_business: "Please select one option",
        u_package: "Please select one option",
        used_ppc_before: "Please select one option",
	},
};

const emailLabelsData = {
	u_first_name: "First Name",
	u_last_name: "Last Name",
	u_email: "Email",
	u_phone: "Phone",
	u_website: "Website",
	u_website_url: "Website URL",
	u_company: "Company",
	u_company_position: "Position in Company",
	u_looking_improve: "Looking to Improve",
    u_describes_business: "Describe your business",
    used_ppc_before: "Have you used Google Ads",
    u_package: "What package are you interested in",
	ref: "Ref",
};

const analyticsEventsData = {
	formView: "ppc_form",
	formSubmitted: "ppc_form_submitted",
	formStep: "ppc_form_step_",
};

export { formInputsData, errorsData, emailLabelsData, analyticsEventsData };
